"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _material = require("@mui/material");

var _Icon = require("../Icon");

var _utilities = require("../../utilities");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["size", "disabled", "children", "isBusy", "isDone"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledFab = (0, _material.styled)(_material.Fab)(function (_ref) {
  var _$concat;

  var theme = _ref.theme,
      disabled = _ref.disabled;
  return (0, _defineProperty2.default)({}, "&.".concat(_utilities.classes.components.MuiFab.root), (_$concat = {}, (0, _defineProperty2.default)(_$concat, "&.".concat(_utilities.classes.states.MuiDisabled), {
    backgroundColor: disabled ? theme.palette.brand.mint.light : theme.palette.brand.mint.main,
    boxShadow: disabled ? "none" : theme.shadows[4],
    color: "white",
    cursor: disabled ? "not-allowed" : "auto",
    pointerEvents: disabled ? "initial" : undefined
  }), (0, _defineProperty2.default)(_$concat, "&.".concat(_utilities.classes.states.MuiFocusVisible), // @ts-ignore - This is fine, we need to define the index types ourselves at
  // some point in `ThemeProvider` to get proper type checking here.
  theme.components.MuiButton.styleOverrides.root["&.".concat(_utilities.classes.states.MuiFocusVisible)]), (0, _defineProperty2.default)(_$concat, "&:active", {
    boxShadow: theme.shadows[8]
  }), (0, _defineProperty2.default)(_$concat, "&:hover", {
    backgroundColor: theme.palette.brand.mint.dark
  }), (0, _defineProperty2.default)(_$concat, "backgroundColor", theme.palette.brand.mint.main), (0, _defineProperty2.default)(_$concat, "boxShadow", theme.shadows[4]), _$concat));
});

var FloatingActionButton = function FloatingActionButton(_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? "medium" : _ref3$size,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
      children = _ref3.children,
      _ref3$isBusy = _ref3.isBusy,
      isBusy = _ref3$isBusy === void 0 ? false : _ref3$isBusy,
      _ref3$isDone = _ref3.isDone,
      isDone = _ref3$isDone === void 0 ? false : _ref3$isDone,
      rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledFab, _objectSpread(_objectSpread({
    disabled: isDone || isBusy || disabled,
    size: size
  }, rest), {}, {
    children: isDone ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      color: "white",
      iconName: "check",
      size: "small"
    }) : isBusy ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CircularProgress, {
      color: "inherit",
      size: "0.75rem",
      thickness: 5
    }) : children
  }));
};

var _default = FloatingActionButton;
exports.default = _default;